import type { FC } from 'react'
import { Redirect } from 'react-router-dom'

export const Dashboard: FC = () => {
  return <Redirect to={__DASHBOARD_URL__} />
}
